import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import useEffectAsync from '../../../hooks/useEffectAsync'
import PerMonthPerTherapistChart from '../charts/PerMonthPerTherapistChart'
import { client } from '../../../client'
import ChartNoData from '../charts/ChartNoData'

const TreatmentsPerMonthSplitByTherapist = () => {
  const { t } = useTranslation('statisticsPage')
  const [data, setData] = useState([])

  useEffectAsync(async () => {
    setData(await client.getTreatmentsPerMonthSplitByTherapist())
  }, [])

  const title = t('getTreatmentsPerMonthSplitByTherapist')
  if (!data.length) return <ChartNoData title={title} />

  const convertedData = data.map((item) => {
    const newItem = { ...item }
    delete newItem.jaar
    return {
      ...newItem,
      maand: `${item.maand} ${item.jaar}`
    }
  })

  const getPsychologists = [...new Set(convertedData.map((el) => el.naam))]

  return (
    <PerMonthPerTherapistChart
      title={title}
      rawData={data}
      convertedData={convertedData}
      getPsychologists={getPsychologists}
      valueKey="aantal"
      id="treatments-psychologist-tags"
    />
  )
}

export default TreatmentsPerMonthSplitByTherapist
